import classes from '../dateinput/DateInput.module.css';

export const DatePickerOverrideClasses = () => {
  return {
    day: classes.day,
    weekday: classes.weekday
  };
};
